export default __webpack_public_path__ + "static/media/photo--sm--misc-4.5d48207d.jpg";